import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import {
  IEbayCategoriesResponse,
  IEbayStoreCategoryResponse,
  IEbayStoreCategoryRefreshResponse,
} from "./../models/EbayOffer";

export default function useEbayCategories() {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  // const categories = useQuery({
  //   queryKey: ["ebayCategories", title],
  //   queryFn: () =>
  //     get<IEbayCategoriesResponse>(
  //       `/ebay/categories?${title ? `query=${title}` : ""}`
  //     ).then((res) => res.data),
  // });

  const categories = useQuery({
    queryKey: ["ebayCategories"],
    queryFn: () =>
      get<IEbayCategoriesResponse>(
        `/ebay/vehiclecategories`
      ).then((res) => res.data),
    staleTime: 1000 * 60 * 60, //1 hour
  });

  // Served from our own table, not eBay, so the picker shows exactly what a publish will send. eBay
  // takes the category's path in an offer, not its id, so the path has to be stored to be resolvable.
  const storeCategories = useQuery({
    queryKey: ["ebayStoreCategories"],
    queryFn: () =>
      get<IEbayStoreCategoryResponse>(
        `/ebay/store/categories/stored`
      ).then((res) => res.data),
    staleTime: 1000 * 60 * 60, //1 hour
  });

  // Run after adding, renaming or moving a shop category on eBay. Nothing picks changes up on its own:
  // the list only changes when somebody edits the shop, and re-reading it per listing would be a
  // request per part on a bulk run.
  const refreshStoreCategories = useMutation({
    mutationFn: () =>
      post<{}, IEbayStoreCategoryRefreshResponse>(
        `/ebay/store/categories/refresh`,
        {}
      ).then((res) => res.data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["ebayStoreCategories"] }),
  });

  return {
    categories,
    storeCategories,
    refreshStoreCategories
  };
}
